module.exports = __webpack_public_path__ + "img/union3.a88d8b9b.png";